<template>
  <div class="item event">
    <div class="top">
      <div class="left">
        <div class="icon"></div>
        <div class="title"><span>Eventos</span></div>
      </div>
      <div class="actions">
        <button :disabled="disableP" @click="getEvent(prev)">
          <i class="fa-solid fa-angle-left"></i>
        </button>
        <button :disabled="disableN" @click="getEvent(next)">
          <i class="fa-solid fa-angle-right"></i>
        </button>
      </div>
    </div>
    <div class="content">
      <template v-if="loading">
        <div class="box" v-for="i in 3" :key="i" style="display:flex;align-items:center;">
          <Sk w="90px" h="86px" rounded="rounded-l-xl rounded-r-none" extra="shrink-0" />
          <div style="flex:1;padding:0 10px;display:flex;flex-direction:column;gap:8px;">
            <Sk w="85%" h="13px" />
            <Sk w="70px" h="22px" rounded="rounded-full" />
          </div>
        </div>
      </template>
      <template v-else-if="events.length > 0">
        <div
          class="box animate__animated animate__headShake"
          v-for="(e, index) in events"
          :key="e.id"
        >
          <RouterLink :to="{ path: `/noticia`, name: 'News', params: { id: e.id, url: e.url } }">
            <div class="img" :style="{ backgroundImage: 'url(' + e.imagem + ')' }"></div>
            <div class="title nobr !font-bold">{{ e.titulo }}</div>
            <div
              class="time"
              :class="{
                '!bg-green-600 !text-white': e.rawDate > 0,
                '!bg-green-600 !text-white !text-[0.8rem] !uppercase !font-bold animate__animated animate__pulse animate__fast animate__infinite':
                  e.rawDate > -7200 && e.rawDate <= 0,
              }"
            >
              {{ getCountdownText(e.rawDate) }}
            </div>
          </RouterLink>
        </div>
      </template>
      <template v-else>
        <div class="mt-32 px-4 text-center">
          <span>Nenhum evento no momento!</span>
        </div>
      </template>
    </div>
  </div>
</template>

<script setup>
import { getEvents } from '@/services/api.js'
import Sk from '@/components/usefulness/Sk.vue'
import { onBeforeUnmount, onMounted, ref } from 'vue'

const events = ref([])
const loading = ref(true)
const next = ref(0)
const prev = ref(0)
const disableP = ref(false)
const disableN = ref(false)

const getCountdownText = (rawDate) => {
  if (rawDate <= -7200) {
    return 'Finalizado'
  } else if (rawDate <= 0) {
    return 'Acontecendo agora!'
  }

  const days = Math.floor(rawDate / (24 * 60 * 60))
  const hours = Math.floor((rawDate % (24 * 60 * 60)) / 3600)
  const minutes = Math.floor((rawDate % 3600) / 60)
  const seconds = rawDate % 60

  // Formata os números com padding zero
  const fHours = String(hours).padStart(1, '0')
  const fMinutes = String(minutes).padStart(2, '0')
  const fSeconds = String(seconds).padStart(2, '0')

  if (days > 0) {
    return `Começa em ${days} dias e ${fHours}:${fMinutes}:${fSeconds} horas`
  } else if (hours > 0) {
    return `Começa em ${fHours}:${fMinutes}:${fSeconds} horas`
  } else if (minutes > 0) {
    return `Começa em ${fMinutes}:${fSeconds} minutos`
  }

  return `Começa em ${fSeconds} segundos`
}

async function getEvent(pag = 1) {
  loading.value = true
  const data = await getEvents({ pag })
  events.value = data.news ?? []
  loading.value = false
  next.value  = data.next
  prev.value  = data.prev
  disableP.value = parseInt(data.prev) === 0
  disableN.value = data.next === 0
}

let interval = null

const updateCountdowns = () => {
  events.value = events.value.map((event) => ({
    ...event,
    rawDate: event.rawDate - 1,
  }))
}

onMounted(() => {
  getEvent()
  interval = setInterval(updateCountdowns, 1000)
})

onBeforeUnmount(() => {
  if (interval) {
    clearInterval(interval)
  }
})
</script>

<style scoped>
.event {
  width: 100%;
  height: 330px;
  @apply max-w-[535px] xl:w-full;
}

.event .top .icon {
  background-color: #f7bd15;
  background-position: -70px 3px;
}

.event .content .box {
  width: 100%;
  float: left;
  height: 86px;
  background-color: #fff;
  border-radius: 12px;
  margin-top: 10px;
  transition: all 0.3s ease;
}

.event .content .box:hover {
  background-color: #e4e9ee;
}

.event .content .box:first-of-type {
  margin-top: 0;
}

.event .box .img {
  float: left;
  width: 90px;
  height: 100%;
  background-position: center;
  background-size: cover;
  border-radius: 12px 0 0 12px;
  background-color: cornflowerblue;
}

.event .box .title,
.event .box .time {
  float: left;
  width: calc(100% - 100px);
  height: 20px;
  margin-left: 10px;
}

.event .box .title {
  font-size: 14px;
  font-weight: 500;
  margin-top: 16px;
  color: var(--color1);
}

.event .box .time {
  width: auto;
  height: 28px;
  padding: 0 6px;
  font-size: 12px;
  font-weight: 500;
  line-height: 28px;
  color: #112535;
  border-radius: 6px;
  margin-top: 8px;
  @apply bg-slate-300;
}
</style>
